import './libs/foundation';

import BannerSlideshow from './components/banner-slideshow';
import CatFilter from './components/cat-filter';
import ContentSlider from './components/content-slider';
import FeatureIcons from './components/feature-icons';
import GoogleMap from './components/google-map';
import Header from './components/header';
import LanguageSwitcher from './components/language-switcher';
import NavBar from './components/nav';
import Paw from './components/paw';
import PracticeMap from './components/practice-map';
import ReadMore from './components/read-more';
import SearchBar from './components/search';
import Testimonials from './components/testimonials';
import Timeline from './components/timeline';
import Video from './components/video';

require( './vue/vue' );

jQuery($ => {
    let bannerSlideshow = new BannerSlideshow();
    let catFilter = new CatFilter();
    let contentSlider = new ContentSlider();
    let featureIcons = new FeatureIcons();
    let googleMap = new GoogleMap();
    let header = new Header();
    let languageSwitcher = new LanguageSwitcher();
    let navBar = new NavBar();
    let paw = new Paw();
    let practiceMap = new PracticeMap();
    let readMore = new ReadMore();
    let searchBar = new SearchBar();
    let testimonials = new Testimonials();
    let timeline = new Timeline();
    let video = new Video();
});
